module.exports = __webpack_public_path__ + "static/Staff-a9c535d6d9bec8e39344cc4b21d0590a.png";